import React, { memo, useContext, useState } from "react";
import { AppContext } from "../context/AppContext";

const SubHeader = memo((props) => {

    const { permissions } = useContext(AppContext)

    const { title, actions } = props

    return (
        <>
            <div className="sub-header-role">
                <div className="textHeader">
                    <h6 className="mt-2">{title}</h6>
                </div>

                <div className="buttonsInsider">
                    {
                        actions?.map((action) => {
                            return action?.isPermitted ? <button
                                className="create-btn-sub-header"
                                variant="primary"
                                onClick={() => {
                                    action.handleClick()
                                }}
                            >
                                {action?.title}
                            </button> : null
                        })
                    }

                </div>
            </div>
        </>
    );
});

export default SubHeader;
